module.exports = __webpack_public_path__ + "img/cockpit-fullscreen_bg.67417f06.png";